export default {
  filters: {
    managers: {
      placeholder: 'Vertriebsleiter',
    },
  },
  metrics: {
    collected_commission: 'Gesamtprovision',
  },
  fields: {
    manager: 'Manager',
    area: 'Standort',
    total_amount: 'Verdienst',
    companies_live: 'Live',
    restaurant: 'Restaurant',
    live_from: 'Live aus',
    plan_amount: 'Planbetrag',
    prepayment_bonus_amount: 'Vorauszahlungsbonus',
    lead_source_bonus_amount: 'Lead-Quelle-Bonus',
    google_business_bonus_amount: 'Google-Business-Verbindungsbonus',
    promo_code_bonus_amount: 'Master-Promo-Code-Bonus',
    smart_pricing_bonus_amount: 'Smart-Pricing-Bonus',
    mobile_app_bonus_amount: 'Bonus für mobile App',
    sales_goal_bonus_amount: 'Bonus für Verkaufsziel',
  },
  buttons: {
    export: 'Export',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
  },
};
